import React from "react";
import { Appointment } from "api/types/appointments";
import { Paper, Stack } from "@mui/material";
import {ANLoadingScreen } from "@answersnow/pkg-theme";
import NextAppointmentCard from "./NextAppointmentCard";
import EmptyNextAppointment from "./EmptyNextAppointment";
import ViewAllAppointments from "./ViewAllAppointments";
import { processCallsForNextAppointment } from "../utils";

interface NextAppointmentProps {
  calls: Appointment[] | null;
}

const NextAppointment: React.FC<NextAppointmentProps> = ({ calls }) => {
  const processedCalls = React.useMemo(() => {
    return processCallsForNextAppointment(calls);
  }, [calls]);

  if (!calls) {
    return (
      <Paper
        component="section"
        elevation={2}
        sx={{
          padding: 10,
          borderRadius: "20px",
          flex: "1 2 0%",
          minHeight: 350,
        }}
      >
        <ANLoadingScreen height="100%" />
      </Paper>
    );
  }

  if (!Array.isArray(processedCalls) || processedCalls.length === 0) {
    return <EmptyNextAppointment />;
  }

  return (
    <Stack
      direction={"column"}
      gap={5}
      sx={{
        width: "100%",
        alignItems: "center",
      }}
    >
      {processedCalls.map((appointment, index) => (
        <NextAppointmentCard
          key={appointment.id}
          appointmentData={appointment}
          showJoinButton={index === 0}
        />
      ))}

      <ViewAllAppointments calls={calls} />
    </Stack>
  );
};

export default NextAppointment;
